import script from "./physicalChannel.vue?vue&type=script&lang=ts&setup=true"
export * from "./physicalChannel.vue?vue&type=script&lang=ts&setup=true"

import "./physicalChannel.vue?vue&type=style&index=0&id=586dd750&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586dd750"]])

export default __exports__